<template>
    <div class="calendar">
        <div class="year">
            <div class="bn" @click="calendarBack">&lt;</div>
            <div>{{calendar.yy}}年 {{calendar.mm+1}}月</div>
            <div class="bn" @click="calendarNext">&gt;</div>
        </div>
        <div class="day" v-for="dd in week">{{dd}}</div>
        <div class="day" :class="{sel:isSel(day.yy,day.mm,day.dd),no:day.mm!==calendar.mm,tag:isTag(day.mm,day.dd)}" v-for="day in calendar.list" @click="day.mm===calendar.mm?selDay(day):''">
            <div class="dd" :class="{future:isFuture(day)}">{{day.dd}}</div>
        </div>
    </div>
</template>
<script>
import Lazy from 'lazy.js'
import calendarDelegate from '@/delegate/calendarDelegate'
import mainDelegate from '@/delegate/mainDelegate'
import { compareNow } from '@/plugin/tools'
export default {
    name: 'Calendar',
    mixins: [calendarDelegate, mainDelegate],
    data() {
        return {
            week: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            selYy: 0,
            selMm: 0,
            selDd: 0
        }
    },
    methods: {
        isFuture(day) {
            return compareNow(day)
        },
        isSel(yy, mm, dd) {
            return yy === this.selYy
                ? mm === this.selMm ? (dd === this.selDd ? true : false) : false
                : false
        },
        selDay(day) {
            if (this.isFuture(day)) return //超過今天不顯示
            this.selYy = day.yy
            this.selMm = day.mm
            this.selDd = day.dd
            this.$emit('sel', day.yy + '/' + (day.mm + 1) + '/' + day.dd)
        },
        isTag(mm, dd) {
            return Lazy(this.recordData).find(item => {
                let da = new Date(item.Date)
                return (
                    this.calendar.mm === da.getMonth() &&
                    da.getMonth() === mm &&
                    da.getDate() === dd
                )
            }) === undefined
                ? false
                : true
        }
    },
    watch: {
        calendar(val) {
            let list = val.list
            let start = val.list[0]
            let startD = start.yy + '/' + (start.mm + 1) + '/' + start.dd
            let end = val.list[val.list.length - 1]
            let endD = end.yy + '/' + (end.mm + 1) + '/' + end.dd
            this.getRecordByDate(startD, endD)
        }
    },
    mounted() {
        let date = new Date()
        this.selMm = date.getMonth()
        this.selYy = date.getFullYear()
        this.selDd = date.getDate()
        this.$emit(
            'sel',
            this.selYy + '/' + (this.selMm + 1) + '/' + this.selDd
        )
        let list = this.calendar.list
        let start = this.calendar.list[0]
        let startD = start.yy + '/' + (start.mm + 1) + '/' + start.dd
        let end = this.calendar.list[this.calendar.list.length - 1]
        let endD = end.yy + '/' + (end.mm + 1) + '/' + end.dd
        this.getRecordByDate(startD, endD)
    }
}
</script>
<style lang="less" scoped>
@import 'val.less';
.calendar {
    height: 330px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    .year {
        display: flex;
        justify-content: space-between;
        .bn {
            width: 50px;
            &:active {
                border-radius: 50px;
                background: @warmGrey;
            }
            &:hover {
                cursor: pointer;
            }
        }
    }
    .day {
        position: relative;
        display: inline-block;
        width: calc(100% / 7);
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        &.tag {
            &:after {
                content: '';
                display: inline-block;
                width: 5px;
                height: 5px;
                border-radius: 3px;
                background: #f00;
                position: absolute;
                bottom: 5px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        &:hover {
            .dd {
                background-color: @warmGrey;
                color: #fff;
                cursor: pointer;
                &.future {
                    background-color: #fff;
                    color: #000;
                    cursor: auto;
                }
            }
        }
        &.no {
            color: @warmGrey;
            &:hover {
                .dd {
                    background-color: initial;
                    color: @warmGrey;
                    cursor: initial;
                }
            }
        }
        .dd {
            display: inline-block;
            width: 40px;
            border-radius: 40px;
            background-color: #fff;
            transition: all 0.5s ease;
        }
        &.sel {
            color: #fff;
            .dd {
                background-color: @main-color;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Calendar.vue